module.exports = __webpack_public_path__ + "a05a3f8d0f71a2fb114d4e153a32e274.svg";